module.exports = __webpack_public_path__ + "img/header_bg2.498c4b6b.png";